export const pdfDate = (pdfReviewDate: any) => {
  let date = pdfReviewDate;
  let day = date.getDate().toString().padStart(2, '0');
  let month = (date.getMonth() + 1).toString().padStart(2, '0'); // January is 0!
  let year = date.getFullYear();
  let hours = date.getHours().toString().padStart(2, '0');
  let minutes = date.getMinutes().toString().padStart(2, '0');

  return {
    date: `${day}/${month}/${year}`,
    time: `${hours}:${minutes}`,
    dateAndTime: `${day}/${month}/${year} ${hours}:${minutes}`,
  };
};
